import { render, staticRenderFns } from "./UrunRezervasyonBilgiYatVilla.vue?vue&type=template&id=1de63a9c&scoped=true"
import script from "./UrunRezervasyonBilgiYatVilla.vue?vue&type=script&lang=js"
export * from "./UrunRezervasyonBilgiYatVilla.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de63a9c",
  null
  
)

export default component.exports